import { useMemo } from 'react';
import { useWindowSize } from 'utils/hooks';

export const useIsBigScreen = () => {
    const [width, height] = useWindowSize(50);

    const isBig = useMemo(() => {
        const w = width || 0;
        const h = height || 0;

        if (w <= 0 || h <= 0) {
            return false;
        }

        // Portrait
        if (h < w) {
            return false;
        }

        const aspectRatio = h / w;

        if (aspectRatio < 1.6) {
            return false;
        }

        // Exclude small screens
        if (w < 900 || h < 1600) {
            return false;
        }

        // Exclude mobile devices
        const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

        if (isMobile) {
            return false;
        }

        // Exclude high DPR (phones and tablets)
        // if ((window.devicePixelRatio || 1) > 1.5) {
        //     return false;
        // }

        return true;
    }, [width, height]);

    return isBig;
};